import Vue from "vue";
import VueRouter from "vue-router";
import pcRouter from "./pcRouter";
import mobileRouter from "./mobileRouter";
import api from "./constants/api";
import axios from 'axios'
// import AuthRequired from "./utils/AuthRequired";
// import {req} from "vuelidate/lib/validators/common";
// import api from "@/constants/api";





Vue.use(VueRouter);


let routerType = "";

// console.log('======= userAgent Info =======');
// console.log(navigator.userAgent);

if (navigator.userAgent.match(/Mobile|iP(hone|od)|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/)) {
  // routerType = mobileRouter;
  routerType = pcRouter
} else {
  routerType = pcRouter
}

const router = new VueRouter({

  linkActiveClass: "active",
  // routes,
  routes: routerType,
  mode: "history"
});

router.beforeEach((to, from, next) => {

  const regExp = /[\{\}\[\]\/?.,;:|\)*~`!^\-+<>@\#$%&\\\=\(\'\"]/gi;
  let sitename = window.location.pathname.split('/')[1];
  console.log(sitename)
  const reqURL = api.changeAPI(sitename, api.basicURL + api.existsPage.site);
  axios.get(reqURL).then(res => {
    if (!res.data.data.exists) {
      next('/');
    }
  }).catch(err => {
    console.log(err.response.data.message);
  });

  if (to.matched.some(record => record.meta.flag)) {
    next();
  } else {
    if (!navigator.userAgent.match(/Mobile|iP(hone|od)|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/)) {
      // routerType = mobileRouter
      routerType = pcRouter
    } else {
      next('/mobile/error');
    }
    if (to.matched.some(record => record.meta.flag1)) {
      next();
    } else {
      var internetExplorer = navigator.userAgent.match(/Trident.*rv[ :]*11\./i);
      var userAgent = navigator.userAgent.match(
        /(opera|chrome|safari|firefox|msie)\/?\s*(\.?\d+(\.\d+)*)/i
      );
      if (internetExplorer) {
        next('/ip/error')
      } else {
        next();
        // console.log("접속경로 " + userAgent[1]);
      }
    }
  }
})

// 오픈날내부점검사용코드 외부아이피 접속차단

// router.beforeEach((to, from, next) => {
//   let ip = null;
//   fetch('https://api.ipify.org?format=json')
//     .then(x => x.json()).then(res => {
//     ip = res.ip;
//     console.log(ip);
//     if(to.matched.some(record => record.meta.flag1)){
//       next();
//     }else{
//     if (ip.split(":")[0] != "118.219.52.15") {
//       console.log(ip);
//       next('/ip/error');
//     } else {
//       console.log(ip);
//       next();
//     }
//     }
//   });
//
//
// })


export default router;
